export default "__VITE_ASSET__Ruw7aIoz__"